var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_19819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4416 12.2656C38.4416 9.53197 37.1175 7.375 34.5868 7.375C32.0455 7.375 30.5078 9.53197 30.5078 12.2442C30.5078 15.4583 32.3231 17.0814 34.9285 17.0814C36.1992 17.0814 37.1602 16.793 37.8863 16.3873V14.2517C37.1602 14.6147 36.3274 14.839 35.2702 14.839C34.2345 14.839 33.3161 14.4759 33.1987 13.2159H38.4202C38.4202 13.0771 38.4416 12.5218 38.4416 12.2656ZM33.1666 11.2511C33.1666 10.0445 33.9034 9.54265 34.5761 9.54265C35.2275 9.54265 35.9216 10.0445 35.9216 11.2511H33.1666Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3856 7.375C25.3391 7.375 24.6664 7.86619 24.2927 8.20789L24.1539 7.54585H21.8047V19.9965L24.4742 19.4305L24.4849 16.4086C24.8693 16.6863 25.4352 17.0814 26.3749 17.0814C28.2863 17.0814 30.0268 15.5437 30.0268 12.1588C30.0161 9.06213 28.2542 7.375 26.3856 7.375ZM25.7449 14.7322C25.1149 14.7322 24.7412 14.5079 24.4849 14.2303L24.4742 10.2688C24.7518 9.95909 25.1362 9.74553 25.7449 9.74553C26.7166 9.74553 27.3893 10.8347 27.3893 12.2335C27.3893 13.6644 26.7273 14.7322 25.7449 14.7322Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1309 6.74426L20.8111 6.16765V4L18.1309 4.56594V6.74426Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8111 7.55566H18.1309V16.899H20.8111V7.55566Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2586 8.34684L15.0877 7.55666H12.7812V16.9H15.4508V10.5679C16.0808 9.74566 17.1486 9.89516 17.4796 10.0126V7.55666C17.1379 7.42853 15.8886 7.19361 15.2586 8.34684Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91886 5.23877L7.31341 5.79403L7.30273 14.3472C7.30273 15.9275 8.488 17.0914 10.0684 17.0914C10.944 17.0914 11.5846 16.9312 11.937 16.739V14.5714C11.5953 14.7102 9.90818 15.2014 9.90818 13.621V9.83033H11.937V7.55591H9.90818L9.91886 5.23877Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70155 10.2688C2.70155 9.85231 3.04325 9.69214 3.60918 9.69214C4.42072 9.69214 5.44581 9.93773 6.25734 10.3755V7.86619C5.37106 7.51381 4.49546 7.375 3.60918 7.375C1.44154 7.375 0 8.50687 0 10.3969C0 13.344 4.05766 12.8742 4.05766 14.1449C4.05766 14.6361 3.63054 14.7963 3.03257 14.7963C2.14629 14.7963 1.01442 14.4332 0.117458 13.942V16.4834C1.11052 16.9105 2.11426 17.092 3.03257 17.092C5.2536 17.092 6.78057 15.9922 6.78057 14.0808C6.76989 10.8988 2.70155 11.4647 2.70155 10.2688Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_19819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4431,
    height: 16,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.c9afb299303322ab1430bbb05f1a357e.svg";
export { ForwardRef as ReactComponent };